// dates format constants
export const DATE_FORMAT = "DD-MM-YYYY";
export const T24_HR_FORMAT = "HH:mm";
export const DATE_FORMAT_24_HR = "DD-MM-YYYY HH:mm";

// regex constants
export const spaceRegex = /^(?=.*\S).+$/;
export const passwordRegex =
  /^(?=.*?[A-Z])(?=.*?[!@#$%^&?()-_+{}|:;"'*])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

// trip types
export const ONE_WAY_TRIP = "one_way";
export const ROUND_TRIP = "round_trip";
export const MULTI_CITY_TRIP = "multi_city";

export const FLIGHT_INQ_TYPE = "flight";
export const FLIGHT_HOTEL_INQ_TYPE = "flightAndhotel";
export const EVISA_INQ_TYPE = "evisa";
export const HAJJ_INQ_TYPE = "hajj_inq";
export const UMRAH_INQ_TYPE = "umrah_inq";
export const ECONOMY_TRAVEL_CLASS = "Economy";
export const BUSSINESS_TRAVEL_CLASS = "Business";
export const DOMAIN_NAME ='chu'
